




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import resize from 'vue-resize-directive';

@Component({
  directives: {
    resize,
  },
})
export default class Splitter extends Vue {
  @Prop({ default: false }) public vertical: boolean;
  @Prop({ default: false }) public border: boolean;
  @Prop({ default: null }) public storageKey: string;

  //左右モード(vertical:false)
  @Prop() public left: number;
  @Prop() public right: number;
  @Prop({ default: 0 }) public minLeft: number;
  @Prop({ default: 0 }) public minRight: number;
  @Prop({ default: true }) public leftVisible: boolean;
  @Prop({ default: true }) public rightVisible: boolean;

  //上下モード(vertical:true)
  @Prop() public top: number;
  @Prop() public bottom: number;
  @Prop({ default: 0 }) public minTop: number;
  @Prop({ default: 0 }) public minBottom: number;
  @Prop({ default: true }) public topVisible: boolean;
  @Prop({ default: true }) public bottomVisible: boolean;
  //最小化フラグ
  @Prop({ default: false }) public minimized: boolean;

  // public isInitialized: boolean = false; //固定幅設定フラグ
  //public fixed: string = 'left';　//left or rightを設定
  public fixedWidth: number = 400; //固定幅
  public active: boolean = false; //ドラッグ開始
  public offset: number = 0; //ドラッグ時からの移動距離
  public start: number = 0; //ドラッグ時のX座標
  public get isLeftTopFixed() {
    return this.vertical ? this.top != undefined : this.left != undefined;
  }
  public get isRightBottomFixed() {
    return this.vertical ? this.bottom != undefined : this.right != undefined;
  }
  public created() {
    if (this.storageKey && localStorage[this.storageKey]) {
      this.fixedWidth = localStorage[this.storageKey];
    } else {
      this.reset();
    }
  }
  public updated() {
    //this.onResize();//min-widthでborderが消える場合がある問題に対するパッチ
    this.setFixedWidth();    
  }

  onResize() {
    //this.initialize();
    this.setFixedWidth();    
    this.$forceUpdate();
  }
  public initialize() {
    if (this.storageKey && localStorage[this.storageKey]) {
      this.fixedWidth = localStorage[this.storageKey];
    } else if (this.vertical == false) {
      if (this.left != undefined) {
        this.fixedWidth = this.left;
      } else if (this.right != undefined) {
        this.fixedWidth = this.right;
      }
    } else {
      if (this.top != undefined) {
        this.fixedWidth = this.top;
      } else if (this.bottom != undefined) {
        this.fixedWidth = this.bottom;
      }
    }
  }

  public reset(){

    if (this.minimized) {
      if (this.left != undefined) {
        this.fixedWidth = this.minLeft;
      } else if (this.right != undefined) {
        this.fixedWidth = this.minRight;
      } else if (this.top != undefined) {
        this.fixedWidth = this.minTop;
      } else if (this.bottom != undefined) {
        this.fixedWidth = this.minBottom;
      }      
    } else {    
      if (this.vertical == false) {
        if (this.left != undefined) {
          this.fixedWidth = this.left;
        } else if (this.right != undefined) {
          this.fixedWidth = this.right;
        }
      } else {
        if (this.top != undefined) {
          this.fixedWidth = this.top;
        } else if (this.bottom != undefined) {
          this.fixedWidth = this.bottom;
        }
      }
    }
    localStorage[this.storageKey] = this.fixedWidth;

  }

  @Watch('fixedWidth')
  public onFixedWidthChanged() {
    //minimized時は記憶しない
    if (this.storageKey && this.minimized == false) {
      localStorage[this.storageKey] = this.fixedWidth;
    }
    //スプリッタ移動時にminimizedプロパティのバインドを更新
    if (this.minimized){
      if ((this.left != undefined && this.fixedWidth > this.minLeft) 
          || (this.right != undefined && this.fixedWidth > this.minRight)
          || (this.top != undefined && this.fixedWidth > this.minTop) 
          || (this.bottom != undefined && this.fixedWidth > this.minBottom)) {
          this.internalEvent = true;
          this.$emit('update:minimized', false);
      } 
    } else {
      if ((this.left != undefined && this.fixedWidth <= this.minLeft) 
          || (this.right != undefined && this.fixedWidth <= this.minRight)
          || (this.top != undefined && this.fixedWidth <= this.minTop) 
          || (this.bottom != undefined && this.fixedWidth <= this.minBottom)) {
          this.$emit('update:minimized', true);          
      }       
    }
  }
  public internalEvent:boolean = false;
  @Watch('minimized')
  public onMinimizedChanged(){
　 //バインド更新時はリセットしない
    if (this.internalEvent) this.internalEvent = false;
    else this.reset();    
  }

  public get splitterStyle() {
    if (this.vertical == false) {
      return this.active ? 'left:' + this.offset + 'px;' : '';
    } else {
      return this.active ? 'top:' + this.offset + 'px;' : '';
    }
  }

  public get leftStyle() {
    if (this.isLeftTopFixed) {
      return  this.rightVisible ? 'width:' + this.fixedWidth + 'px;' + (this.minLeft == 0 ? '' : 'min-width:' + this.minLeft.toString() + 'px;') :'width:100%' ;
    } else {
      return this.rightVisible ? 'flex: 1;' + (this.minLeft == 0 ? '' : 'min-width:' + this.minLeft.toString() + 'px;') : 'width:100%';
    }
  }

  public get rightStyle() {
    if (this.isRightBottomFixed) {
      return this.leftVisible ? 'width:' + this.fixedWidth + 'px;' + (this.minRight == 0 ? '' : 'min-width:' + this.minRight.toString() + 'px;') + (this.border ? 'border-left:thin solid lightgray;' : ''):'width:100%';
    } else {
      return this.leftVisible ? 'flex: 1;'  + (this.minRight == 0 ? '' : 'min-width:' + this.minRight.toString() + 'px;') + (this.border ? 'border-left:thin solid lightgray;' : '') :'width:100%';
    }
  }

  public get topStyle() {
    if (this.isLeftTopFixed) {
      return this.bottomVisible ? 'height:' + this.fixedWidth + 'px;' + (this.minTop == 0 ? '' : 'min-height:' + this.minTop.toString() + 'px;')  : 'height:100%';
    } else {
      return this.bottomVisible ? 'flex: 1;' + (this.minTop == 0 ? '' : 'min-height:' + this.minTop.toString() + 'px;')   : 'height:100%';
    }
  }

  public get bottomStyle() {
    if (this.isRightBottomFixed) {
      return this.topVisible ? 'height:' + this.fixedWidth + 'px;' + (this.minBottom == 0 ? '' : 'min-height:' + this.minBottom.toString() + 'px;') + (this.border ? 'border-top:thin solid lightgray;' : '') : 'height:100%';
    } else {
      return this.topVisible ? 'flex: 1;' + (this.minBottom == 0 ? '' : 'min-height:' + this.minBottom.toString() + 'px;') + (this.border ? 'border-top:thin solid lightgray;' : '') : 'height:100%';
    }
  }

  onDown(e: any) {
    // if (this.isInitialized == false) {
    //   //比率でスタートした場合に固定幅を取得する
    //   this.setFixedWidth();
    //   this.isInitialized = true;
    // }
    // this.setFixedWidth();
    this.active = true;
    this.offset = 0;

    const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
    this.start = this.vertical ? location.clientY : location.clientX;
    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }
  }

  onUp(e: any) {
    if (this.active) {
      //固定幅を更新する
      const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
      if (this.vertical == false) {
        var clientLength = this.$el.clientWidth;        
        if (this.isLeftTopFixed) {
          this.fixedWidth += location.clientX - this.start;   
        } else {
          this.fixedWidth -= location.clientX - this.start;           
        }
      } else {
        var clientLength = this.$el.clientHeight;
        if (this.isLeftTopFixed) {
          this.fixedWidth += location.clientY - this.start;      
        } else {
          this.fixedWidth -= location.clientY - this.start;
        }
      }

      this.active = false;
      this.offset = 0;
      this.setFixedWidth();
    }
  }

  onMove(e: any) {
    if (this.active) {
      const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
      if (this.vertical == false) {
        this.offset = location.clientX - this.start;
      } else {
        this.offset = location.clientY - this.start;
      }
      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }
    }
  }

  setFixedWidth() {
      //fixedWidthの上限・下限を制御
      if (this.vertical == false) {
        var clientLength = this.$el.clientWidth;        
        if (this.isLeftTopFixed) {
          if (this.minLeft && this.fixedWidth <= this.minLeft) this.fixedWidth = this.minLeft;
          else if (this.minRight && this.fixedWidth > clientLength - this.minRight) this.fixedWidth = clientLength - this.minRight; //上限               
        } else {
          if (this.minRight && this.fixedWidth <= this.minRight) this.fixedWidth = this.minRight;          
          else if (this.minLeft && this.fixedWidth > clientLength - this.minLeft) this.fixedWidth = clientLength - this.minLeft; //上限              
        }
      } else {
        var clientLength = this.$el.clientHeight;
        if (this.isLeftTopFixed) {
          if (this.minTop && this.fixedWidth <= this.minTop) this.fixedWidth = this.minTop;         
          else if (this.minBottom && this.fixedWidth > clientLength - this.minBottom) this.fixedWidth = clientLength - this.minBottom; //上限           
        } else {
          if (this.minBottom && this.fixedWidth <= this.minBottom) this.fixedWidth = this.minBottom;  //下限
          else if (this.minTop && this.fixedWidth > clientLength - this.minTop) this.fixedWidth = clientLength - this.minTop; //上限
        }
      }
  }
}
